import { ImgComparisonSlider } from "@img-comparison-slider/vue";
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component("ImgComparisonSlider", ImgComparisonSlider);
});
